const formatDateItem = (unitName: string, value: number): string => {
  if(value !== 1) unitName += 's';
  return value ? `${value} ${unitName}` : '';
}

const getFormattedDuration = (duration: number | undefined | null): string | undefined => {
  if (!duration) {
    return;
  }

  const weeks = Math.floor(duration / 7);
  const days = duration % 7;

  const weeksVal = formatDateItem('week', weeks);
  const daysVal = formatDateItem('day', days);

  return `${weeksVal} ${daysVal}`;
}

export default getFormattedDuration;